import React from 'react';
import { Button, Stack, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SettingsSectionCard from './SettingsSectionCard';
import { buildSpecialRequestSettingsSavePayload, SPECIAL_REQUEST_FULFILL_ORDER_STATUSES } from '../../utils/specialRequestSettings';

export default function SpecialRequestsSettingsSection({
  form,
  setField,
  onSave,
  onReset,
  loading,
  saving,
  error,
  success,
  setSuccess,
}) {
  const { t } = useTranslation();
  const settings = form.specialRequestSettings || {};

  const setFulfillOrderStatus = (value) => {
    setField('specialRequestSettings', {
      ...settings,
      fulfillOrderStatus: value,
    });
  };

  if (loading) return null;

  return (
    <SettingsSectionCard
      title={t('settings.sections.specialRequests')}
      description={t('settings.specialRequests.description')}
      error={error}
      success={success}
      successMessage={t('settings.saved')}
      onCloseSuccess={() => setSuccess(false)}
    >
      <Stack spacing={2.5}>
        <FormControl>
          <FormLabel>{t('settings.specialRequests.fulfillOrderStatus')}</FormLabel>
          <RadioGroup
            value={settings.fulfillOrderStatus || SPECIAL_REQUEST_FULFILL_ORDER_STATUSES.READY}
            onChange={(e) => setFulfillOrderStatus(e.target.value)}
          >
            <FormControlLabel
              value={SPECIAL_REQUEST_FULFILL_ORDER_STATUSES.READY}
              control={<Radio size="small" />}
              label={t('settings.specialRequests.fulfillOrderStatusReady')}
            />
            <FormControlLabel
              value={SPECIAL_REQUEST_FULFILL_ORDER_STATUSES.MEMO}
              control={<Radio size="small" />}
              label={t('settings.specialRequests.fulfillOrderStatusDelivered')}
            />
          </RadioGroup>
        </FormControl>

        <Stack direction="row" spacing={1}>
          <Button variant="contained" onClick={() => onSave(buildSpecialRequestSettingsSavePayload(form))} disabled={saving}>
            {saving ? t('common.saving') : t('common.save')}
          </Button>
          <Button onClick={onReset} disabled={saving}>{t('common.reset')}</Button>
        </Stack>
      </Stack>
    </SettingsSectionCard>
  );
}
